import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { usePostHog } from "../../services/posthog/posthog.provider"

const PostHogPageviewTracker = () => {
  const posthog = usePostHog()
  const location = useLocation()

  useEffect(() => {
    if (!posthog) return
    posthog.capture("$pageview", { $current_url: window.location.href })
  }, [posthog, location])

  return null
}

export default PostHogPageviewTracker
